export const passwordResetConfirmationText = 'RESET';

export const passwordResetWarningMessage =
    'This action cannot be undone. You are about to expire the passwords for all users across all environments.';

export const passwordResetMessageList = [
    'Current users will stay logged in but must reset their password at their next login.',
    'Users will be unable to access the system until they complete the reset process.',
    'A record of this action will be sent to ModMed.'
];

export const passwordResetSuccessMessage =
    'Password reset initiated successfully. All users will be required to create a new password at their next login.';

export const passwordResetSuccessTitle = 'Password Reset';

export const passwordResetErrorMessage =
    'An error occurred while initiating the password reset. Please try again.';

export const passwordResetServiceUnavailableMessage =
    'Password reset is temporarily unavailable, please try again later.';

export const passwordResetErrorTitle = 'Password Reset Failed';
